import { render } from "./users-list.component.vue?vue&type=template&id=3d2db674&ts=true"
import script from "./users-list.component.vue?vue&type=script&lang=ts"
export * from "./users-list.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__